
import React, { useState, useRef } from "react";
import { axiosInstance2 } from "../../../utils/AxiosInstance";
import handleError from "../../../constant/handleError";
import { CircularProgress } from "@mui/material";

const  UploadWorkModal=({
  openImageModal,
  isSelectedData,
  setSelectedData,
  handleCloseUploadImages,
  showAlert,
}) =>{
  const fileInputRef = useRef(null);

  const [loadingBtn, setLoadingBtn] = useState(false);

  const [formData, setFormData] = useState({
    singleImage: null,
    singleImagePreview: "",
  });

  const [errors, setErrors] = useState({});

  const handleImageChange = (e) => {
    const file = e.target.files[0];

    if (file) {
      if (file.size > 1024 * 1024 * 1024) {
        setErrors((prev) => ({
          ...prev,
          singleImage: "File size exceeds 1GB limit.",
        }));
        return;
      }

      setFormData((prev) => ({
        ...prev,
        singleImage: file,
        singleImagePreview: URL.createObjectURL(file),
      }));

      setErrors((prev) => ({
        ...prev,
        singleImage: "",
      }));
    }
  };

  const handleRemoveImage = () => {
    setFormData({
      singleImage: null,
      singleImagePreview: "",
    });

    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const handleUploadFinalImages = async () => {
      console.log("geo",isSelectedData.geoImage)
      const validationErrors = {};

    if (!formData.singleImage) {
      validationErrors.singleImage = "Image is required.";
    }

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setLoadingBtn(true);

    try {
      const data = new FormData();

      data.append("image", formData.singleImage);    

      const response = await axiosInstance2.patch(
        `farmerbooking/admin/upload-final-work/${isSelectedData?._id}`,
        data
      );

      const updatedBooking = response?.data?.results;
    setSelectedData((prevSelected) => {     
      let updatedHistory = [...(prevSelected.bookingStatusHistory || [])];
           const hasWorkStarted = updatedHistory.some(
        (s) => s.bookingTracking === "WORKCOMPLETED"
      );
      const hasImages = updatedBooking.workImages && updatedBooking.workImages.length > 0;

       if (!hasWorkStarted && hasImages) {
        updatedHistory.push({
          _id: updatedBooking._id,
          bookingTracking: "WORKCOMPLETED",
          entryBy: updatedBooking.lastUpdatedBy || "OWNER",
          time: updatedBooking.updatedAt,
        });
      }

      return {
        ...prevSelected,
        workStatus: updatedBooking.workStatus,
        workImages: updatedBooking.workImages,
         lastStatus:updatedBooking.lastStatus,
         geoImage: updatedBooking?.geoImage,
        bookingStatusHistory: updatedHistory, // Saves the modified array here
      };
    });
      // setSelectedData((prevSelected) => ({
      //   ...prevSelected,
      //   workStatus: updatedBooking?.workStatus,
      //   lastStatus:updatedBooking.lastStatus,
      //   geoImage: updatedBooking?.geoImage,
      // }));

      showAlert("success", response?.data?.message);

      handleCloseUploadImages();
    } catch (error) {
      handleError(error, showAlert);
    } finally {
      setLoadingBtn(false);
    }
  };

  return (
    <>
      {openImageModal && (
        <>
          <div className="modal-backdrop show"></div>

          <div
            className="modal show d-block"
            tabIndex="-1"
            role="dialog"
          >
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                {/* Header */}
                <div className="modal-header border-0">
                  <h6 className="modal-title fw-semibold">
                    Upload Image
                  </h6>

                  <button
                    type="button"
                    className="btn-close"
                    onClick={handleCloseUploadImages}
                  ></button>
                </div>

                {/* Body */}
                <div className="modal-body">
                  <div className="card w-100 radius-10 mb-0 shadow-none p-3">
                    <div className="card-body p-0">
                      <div className="row g-3">
                        {/* Image Upload */}
                        <div className="col-lg-12">
                          <label className="form-label fw-medium">
                            Choose Image
                          </label><span className="text-danger"> *</span>

                          <input
                            type="file"
                            ref={fileInputRef}
                            accept="image/jpeg,image/png,image/jpg"
                            className={`form-control ${
                              errors.singleImage
                                ? "is-invalid"
                                : ""
                            }`}
                            onChange={handleImageChange}
                          />

                          {errors.singleImage && (
                            <div className="invalid-feedback d-block">
                              {errors.singleImage}
                            </div>
                          )}

                          {/* Preview */}
                          {formData.singleImagePreview && (
                            <div className="mt-3 position-relative d-inline-block">
                              <img
                                src={formData.singleImagePreview}
                                alt="Upload Preview"
                                style={{
                                  width: "120px",
                                  height: "120px",
                                  objectFit: "cover",
                                  borderRadius: "8px",
                                  border: "1px solid #ddd",
                                }}
                              />

                              <button
                                type="button"
                                className="btn btn-danger btn-sm position-absolute top-0 end-0 rounded-circle"
                                style={{
                                  transform:
                                    "translate(30%, -30%)",
                                  width: "24px",
                                  height: "24px",
                                  padding: 0,
                                }}
                                onClick={handleRemoveImage}
                              >
                                ×
                              </button>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Footer */}
                <div className="modal-footer border-0 d-flex justify-content-between">
                  <button
                    className="btn btn-outline-secondary"
                    onClick={handleCloseUploadImages}
                  >
                    Close
                  </button>

                  {loadingBtn ? (
                    <button
                      className="btn btn-primary pb-0 text-right"
                      disabled
                    >
                      <CircularProgress
                        size={22}
                        className="text-white"
                      />
                    </button>
                  ) : (
                    <button
                      className="btn btn-primary"
                      onClick={handleUploadFinalImages}
                    >
                      <i className="bx bx-check me-1"></i>
                      Update
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
}
export default UploadWorkModal;